module.exports = __webpack_public_path__ + "img/newlogo2.a1731e57.png";